import React from "react";
import { Col, Row, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <>
      <main className="log-main">
        <div className="log-inner container-fluid">
          <Row>
            <Container>
              <Row>
                <Col xl="12" lg="12" md="12" className="notfound-pnl">
                  <h1>
                    <span>404</span> Page Not Found
                  </h1>
                  <p>The Requested URL /error was not found on this server</p>
                  <Link className="reg-btn" to="/">
                    Back to Home
                  </Link>
                </Col>
              </Row>
            </Container>
          </Row>
        </div>
      </main>
    </>
  );
}

export default NotFound;
